import {
  CorrelationCouple,
  IGenericObject,
  RangeParam,
  TableWithFields,
} from '@types'

export const defaultCorrelationQueryParams = {
  num_num_association: 'pearson',
  nom_nom_association: 'cramer',
  nom_num_association: 'correlation_ratio',
  nan_strategy: 'drop_samples',
  nan_replace_value: 0,
}

export const cleanQueryFields = (params: TableWithFields) => {
  const filterKeys = Object.keys(params.filters)
  return params.keys
    .map(({ value }) => value)
    .filter((k) => !filterKeys.includes(k))
}

export const convertResponseToNivoFormat = (data: IGenericObject<any>) => {
  const nivoData: any[] = []
  Object.keys(data).forEach((attrKey) => {
    const bucket = data[attrKey]
    const nivoBucketData = Object.keys(bucket).map((bucketKey) => {
      return {
        x: bucketKey,
        y: parseFloat(bucket[bucketKey].toFixed(2)),
      }
    })
    const nivoBucket = {
      id: attrKey,
      data: nivoBucketData,
    }
    nivoData.push(nivoBucket)
  })
  return nivoData
}

export const sortCorrelation = (
  data: IGenericObject<any>
): {
  highest: CorrelationCouple[]
  lowest: CorrelationCouple[]
} => {
  const flattened: { attributo_1: string; attributo_2: string; c_i: number }[] =
    []

  const added_couples: string[] = []

  Object.keys(data).forEach((k1) => {
    Object.keys(data[k1]).forEach((k2) => {
      if (data[k1][k2] === 1.0) return
      if (added_couples.includes(k2 + '___' + k1)) return
      flattened.push({
        attributo_1: k1,
        attributo_2: k2,
        c_i: data[k1][k2].toFixed(2),
      })
      added_couples.push(k1 + '___' + k2)
    })
  })
  const sorted = flattened.sort((a, b) => a.c_i - b.c_i)

  return {
    highest: sorted.slice(-5).reverse(),
    lowest: sorted.slice(0, 5),
  }
}

export const getPercentileRanges = (
  fieldName: string,
  fieldStats: IGenericObject<any>
): RangeParam | undefined => {
  if (!fieldStats.numerical) {
    return undefined
  }
  return {
    field: fieldName,
    domain: [
      fieldStats.numerical.percentiles.values['5.0'] > 0
        ? fieldStats.numerical.percentiles.values['5.0']
        : 0.1,
      fieldStats.numerical.percentiles.values['95.0'],
    ],
  }
}
